module.exports = __webpack_public_path__ + "img/load-more-icon.3e5abec8.png";